import "./filterForm.css";
import React, { useEffect } from "react";
import {
  Autocomplete,
  Checkbox,
  FormControl,
  Grid,
  InputLabel,
  TextField,
} from "@mui/material";
import { useSelector } from "react-redux";
import { terminalValuesSelector } from "../../AppState/selectors";
import { useTerminalMaster } from "../../@hooks/useTerminalMaster";
import { ETab, FILTER_SHOW_DESTINATION, FILTER_SHOW_PICKUP_TERMINAL, FILTER_SHOW_REPORTING, FORM_STYLES, S_GRID_PROPS } from "../../constants";

interface TerminalAutocompleteProps {
  tabPosition: ETab;
  tid: string[];
  setTid: (value: string[]) => void;
  did: string[];
  setDid: (value: string[]) => void;
  rTid: string[];
  setRTid: (value: string[]) => void;
}

const TerminalAutocomplete: React.FC<TerminalAutocompleteProps> = ({
  tabPosition,
  tid,
  setTid,
  did,
  setDid,
  rTid,
  setRTid,
}) => {
  const terminalMasterData: string[] = useSelector(terminalValuesSelector);
  const { loadTerminals } = useTerminalMaster();

  const handleChangeTID = (value: string[]) => {
    setTid(value);
  };

  const handleChangeDTID = (value: string[]) => {
    setDid(value);
  };

  const handleChangeRTid = (value: string[]) => {
    setRTid(value);
  };

  const [oInputValue, setOInputValue] = React.useState<string>("");
  const [dInputValue, setDInputValue] = React.useState<string>("");
  const [rInputValue, setRInputValue] = React.useState<string>("");

  const onAutoInputChange = (v: string, r: string, type: string = "") => {
    if (r === "input") {
      const setterMap: Record<string, (value: string) => void> = {
        origin: setOInputValue,
        destination: setDInputValue,
        reporting: setRInputValue,
      };

      setterMap[type]?.(v);
    }
  };

  const renderAutoComplete = (
    label: string,
    id: string,
    value: string[],
    onChange: (value: string[]) => void,
    inputValue: string,
    setInputValue: (value: string) => void
  ) => {
    return (
      <Grid item {...S_GRID_PROPS} className="hide-no-option">
        <FormControl fullWidth size="small">
          <InputLabel htmlFor={id} style={FORM_STYLES.LABEL} shrink={true}>
            {label}
          </InputLabel>
          <Autocomplete
            id={id}
            key={`search-${id}`}
            disablePortal
            className="custom-autocomplete"
            multiple
            forcePopupIcon={false}
            getOptionLabel={(option) => option || ""}
            disableCloseOnSelect
            value={value}
            style={FORM_STYLES.LABEL}
            options={terminalMasterData}
            onChange={(e, v) => {
              onChange(v);
              setInputValue("");
            }}
            inputValue={inputValue}
            onClose={(_e) => {
              setInputValue("");
            }}
            onInputChange={(e, v, r) => onAutoInputChange(v, r, id)}
            renderOption={(props, option) => (
              <li {...props} title={option}>
                <Checkbox checked={value.includes(option)} />
                {option}
              </li>
            )}
            renderInput={(params) => (
              <TextField
                autoComplete="off"
                {...params}
                variant="outlined"
                className="test"
              />
            )}
            // renderTags={renderTags}
            renderTags={(value) => (
              <div
                className="auto-complete-selected-container"
                title={value.join(", ")}
              >
                {value.join(", ")}
              </div>
            )} // Add renderTags property to customize rendering of selected values
          />
        </FormControl>
      </Grid>
    );
  };

  useEffect(() => {
    if (terminalMasterData.length === 0) {
      loadTerminals();
    }
  }, [terminalMasterData, loadTerminals]);

  return (
    <>
      {renderAutoComplete(
        " Origin TID",
        "origin",
        tid,
        handleChangeTID,
        oInputValue,
        setOInputValue
      )}
      {/* Destination TID */}
      {FILTER_SHOW_DESTINATION.includes(
        tabPosition
      ) &&
        renderAutoComplete(
         FILTER_SHOW_PICKUP_TERMINAL.includes(
        tabPosition
      ) ? "Destination/Pickup TID" : "Destination TID",
          "destination",
          did,
          handleChangeDTID,
          dInputValue,
          setDInputValue
        )}
      {/* Reporting TID */}
      {FILTER_SHOW_REPORTING.includes(tabPosition) &&
        renderAutoComplete(
          "Reporting TID",
          "reporting",
          rTid,
          handleChangeRTid,
          rInputValue,
          setRInputValue
        )}
    </>
  );
};

export default TerminalAutocomplete;
